import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
const Toefl = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Exam"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Exam"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"TOEFL - Test of English as a Foreign Language"} pagename={"TOEFL"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <p className="loan-elegibility-des mt-0">A standardized exam called the Test of English as a Foreign Language (TOEFL) helps to assess non-native speakers’ level of English language competency in preparation for further study or employment in English-speaking environments. The TOEFL, developed and administered by the Educational Testing Service (ETS), evaluates a test-taker’s understanding and use of English in a classroom environment. There are four areas of the test: writing, speaking, listening, and reading.<br /><br />
                                The portions on reading and listening measure understanding, the section on speaking evaluates oral ability, and the one on writing tests written expression. The TOEFL is an essential tool for overseas students since its results are widely recognized by universities and other institutions throughout the world. By ensuring that people can interact and flourish in English-based educational and work environments, the exam seeks to provide an objective and precise evaluation of language competency for a varied group of international applicants. </p>
                            <h5 className="about-head">Types of TOEFL</h5>
                            <p className="loan-elegibility-des">The TOEFL is offered in three primary formats by ETS: TOEFL iBT, TOEFL PBT, and TOEFL Essentials.</p>
                            <ol className="subhead-ul">
                                <li><b>TOEFL iBT :</b> This exam is offered at approved testing centers and is conducted online. There are four components to the test: speaking, writing, listening, and reading.</li>
                                <li><b>TOEFL PBT :</b> It is a Paper-Based Test, which means it is administered on paper. The test may be taken even in places without a facility or internet connection. The exam is divided into three sections: writing, listening, and reading. Due to the unavailability of a technological system for capturing responses, there is no speaking component included. This exam will no longer be available as of April 11, 2022. However, after the test date, the results are still valid for two years.</li>
                            </ol>
                            <h5 className="about-head">TOEFL Essentials</h5>
                            <p className="loan-elegibility-des">It was only recently released. The TOEFL iBT is comparable to it. The students can submit a video Personal Statement to the universities, and the test lasts just 1.5 hours, which is the only difference. Institutions just use the personal statement video to learn more about the candidate; it is not evaluated. You can do the exam at your own house. <br /><br />
                                For people and students looking to study the language, there are additional TOEFL exams.</p>
                            <ol className="subhead-ul">
                                <li>TOEFL Primary is for ages 8 and up.</li>
                                <li>TOEFL Junior is for ages 11 and up.</li>
                                <li>TOEFL ITP is for anyone aged 16 and above.</li>
                            </ol>
                            <h5 className="about-head">TOEFL Highlights</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Specific</th>
                                        <th>Explanation</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>Exam Name</td>
                                        <td>TOEFL</td>
                                    </tr>
                                    <tr>
                                        <td>Full-form</td>
                                        <td>Test of English as a Foreign Language</td>
                                    </tr>
                                    <tr>
                                        <td>Official Website</td>
                                        <td>The TOEFL Family of Assessments</td>
                                    </tr>
                                    <tr>
                                        <td>Accepted Countries</td>
                                        <td>Institutions in the USA, Canada, UK, New Zealand, and Australia.</td>
                                    </tr>
                                    <tr>
                                        <td>Conducted By</td>
                                        <td>Educational Testing Service (ETS)</td>
                                    </tr>
                                    <tr>
                                        <td>Mode of Exam</td>
                                        <td>Internet-based, Home Tests</td>
                                    </tr>
                                    <tr>
                                        <td>Test Fee - TOEFL IBT</td>
                                        <td>$190</td>
                                    </tr>
                                    <tr>
                                        <td>Test Fee TOEFL Home Edition</td>
                                        <td>$190</td>
                                    </tr>
                                    <tr>
                                        <td>Test Fee - TOEFL Essentials</td>
                                        <td>$100</td>
                                    </tr>
                                    <tr>
                                        <td>Late Registration Charges</td>
                                        <td>$40</td>
                                    </tr>
                                    <tr>
                                        <td>Score Range</td>
                                        <td>
                                            0 - 120 (four sections of 30 points each)</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5 className="about-head">Which well-known universities accept scores from the TOEFL?</h5>
                            <p className="loan-elegibility-des">The TOEFL is accepted at more than 11,000 universities throughout the world. Major universities are now reviewing and approving the newly released TOEFL Essentials. </p>
                            <h6 className="subhead">University</h6>
                            <ol className="subhead-ul">
                                <li>University of Montreal (Canada)</li>
                                <li>University of Winnipeg (Canada)</li>
                                <li>University of British Columbia (Canada)</li>
                                <li>Seneca College (Canada)</li>
                                <li>Essec Business School (France)</li>
                                <li>Erasmus University (Netherlands)</li>
                                <li>University of Amsterdam (Netherlands)</li>
                                <li>London School of Economics and Political Science</li>
                                <li>University of Essex</li>
                                <li>University of Glasgow</li>
                                <li>University of Leeds</li>
                                <li>University of Westminster</li>
                                <li>University of Arizona</li>
                                <li>University of California, Berkeley</li>
                                <li>University of Denver</li>
                                <li>University of Colorado</li>
                                <li>Yale University</li>
                                <li>University of Florida</li>
                                <li>Northwestern University</li>
                                <li>Johns Hopkins University</li>
                                <li>University of Maryland</li>
                                <li>Boston University</li>
                                <li>Columbia University</li>
                                <li>New York University</li>
                                <li>Pace University</li>
                                <li>Cornell University</li>
                                <li>Oregon State University</li>
                                <li>University of Michigan</li>
                            </ol>
                            <h5 className="about-head">Which countries take the TOEFL score into account?</h5>
                            <p className="loan-elegibility-des">English-speaking countries include the United States, Canada, the United Kingdom, Australia, New Zealand, and some European nations that accept the TOEFL.</p>
                            <h5 className="about-head">What qualifications are needed to be eligible for the TOEFL exam?</h5>
                            <p className="loan-elegibility-des">The TOEFL exam has no requirements. For academic purposes alone, such as studying in an English-speaking nation, students may also take the exam to gauge their proficiency in the language. Additionally, there are no age limitations.</p>
                            <h5 className="about-head">Exam fee for the TOEFL</h5>
                            <p className="loan-elegibility-des">The cost of the test varies based on where you live. The exam fee for applicants from India is as follows:
                                <br /><br />
                                TOEFL iBT – $190</p>
                            <h5 className="about-head">Crucial dates for the TOEFL examination</h5>
                            <p className="loan-elegibility-des">The TOEFL iBT exam is conducted more than 60 times a year throughout the year. With an appointment as early as 24 hours after registration, the TOEFL Home Edition is available 24 hours a day, 4 days a week.</p>
                            <h5 className="about-head">The IELTS Academic Test's Format</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Skill</th>
                                        <th>Format</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>Listening Section</td>
                                        <td>Questions - 30 to 40<br /><br />
                                            Duration - 41 - 57 minutes</td>
                                    </tr>
                                    <tr>
                                        <td>Reading Section</td>
                                        <td>Questions - 30 to 40<br /><br />
                                            Duration - 54 - 72 minutes</td>
                                    </tr>
                                    <tr>
                                        <td>Writing Section</td>
                                        <td>Questions - 2<br /><br />
                                            Duration - 50 minutes</td>
                                    </tr>
                                    <tr>
                                        <td>Speaking Section</td>
                                        <td>Questions - 4<br /><br />
                                            Duration - 17 minutes</td>
                                    </tr>

                                </tbody>
                            </table>
                            <h5 className="about-head">What is the minimum and maximum score on the TOEFL?</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Skill</th>
                                        <th>Level</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>Listening Section</td>
                                        <td>Advanced (22–30)<br /><br />High-Intermediate (17–21)<br /><br />Low-Intermediate (9–16)<br /><br />Below Low-Intermediate (0–8)</td>
                                    </tr>
                                    <tr>
                                        <td>Reading Section</td>
                                        <td>Advanced (24–30)<br /><br />
                                            High-Intermediate (18–23)<br /><br />
                                            Low-Intermediate (4–17)<br /><br />
                                            Below Low-Intermediate (0–3)</td>
                                    </tr>
                                    <tr>
                                        <td>Writing Section</td>
                                        <td>Advanced (24–30)<br /><br />
                                            High-Intermediate (17–23)<br /><br />
                                            Low-Intermediate (13–16)<br /><br />
                                            Basic (7–12)<br /><br />
                                            Below Basic (0–6)</td>
                                    </tr>
                                    <tr>
                                        <td>Speaking Section</td>
                                        <td>Advanced (25–30)<br /><br />
                                            High-Intermediate (20–24)<br /><br />
                                            Low-Intermediate (16–19)<br /><br />
                                            Basic (10–15)<br /><br />
                                            Below Basic (0–9)</td>
                                    </tr>

                                </tbody>
                            </table>
                            <p className="loan-elegibility-des">The test consists of four portions.<br /><br />A 30-point scale is used to grade each section.<br /><br />A section’s total score ranges from 0 to 120 when combined together.</p>
                            <table></table>
                            <h5 className="about-head">What is an effective approach for getting ready for the TOEFL exam?</h5>
                            <p>The best preparation advice for improving your score</p>
                            <ol className="subhead-ul">
                                <li>Set a timeline: create a plan and give equal weight to each section.</li>
                                <li>Concept clarity: Rather than memorizing facts by heart, try to grasp the idea and then answer questions based on how well you understand it.</li>
                                <li>A minimum of three months prior to the exam date, start your preparation by starting your studies.</li>
                                <li>Practice and mock exams: To assess your abilities, do at least one practice test each week.</li>
                            </ol>
                            <h5 className="about-head">List of Test Centers in India</h5>
                            <p className="loan-elegibility-des">The exam is accessible all around India. Furthermore, students who are unable to travel can take the TOEFL Home Edition test. On the ETS website, you may verify the exam locations, dates, and times that are available.</p>
                            <h5 className="about-head">Requirements for TOEFL Eligibility</h5>
                            <p>Since the TOEFL is a test of English language skills, it is among the most thorough in the world while having no qualifying requirements. The test is open to students of all ages and educational levels who are not native English speakers.<br /><br />
                                TOEFL exam eligibility is restricted to a basic minimum of having completed high school to make it as wide and inclusive as feasible for students from all over the world. Students will have an equal opportunity to succeed regardless of their local curriculum or teaching style because the test is structured to just focus on the language component.</p>
                            <h5 className="about-head">TOEFL Registration</h5>
                            <p>Creating an account on the ETS website is the first step in the TOEFL registration procedure. Students must next fill in the personal and other data, which must be filled out carefully as they will be confirmed later. An applicant must next select a date and reserve a spot from the list of available dates. A student is then sent to the payment page. After making the payment, the registration procedure is finished; simply print off the acknowledgment receipt.</p>
                            <h5 className="about-head">Colleges that Accept TOEFL Scores</h5>
                            <p>Since the TOEFL results are accepted by over 10,000 universities, the TOEFL qualifying requirements are minimal.<br /><br />
                                A quick summary of the nations that accept TOEFL scores is as follows:</p>
                            <ol className="subhead-ul">
                                <li><b>US :</b> The TOEFL is accepted for admission at 9 out of 10 US colleges.</li>
                                <li><b>UK :</b> The TOEFL is accepted by more than 98% of universities in the United Kingdom The reputable Russell group’s 100% of colleges accept TOEFL results.</li>
                                <li><b>Canada :</b> In Canada, the TOEFL is accepted at about 80% of universities.</li>
                                <li>Several French and German institutions accept the TOEFL as one of the generally recognized English proficiency exams for students.</li>
                            </ol>
                            <h5 className="about-head">Proficiencies Examined in TOEFL</h5>
                            <p className="loan-elegibility-des">The Listening, Reading, and Writing sections of the test are the primary areas of focus. The TOEFL syllabus for exams administered on paper does not include a Speaking portion. To get a respectable exam result, students should practice these skills a lot.</p>
                            <h5 className="about-head">TOEFL Syllabus</h5>
                            <p>The primary elements of the curriculum, include the Reading, Writing, Speaking, and Listening sections. To evaluate an applicant’s capacity to fit into the social and academic life of English-speaking nations, the TOEFL Exam syllabus employs a comprehensive methodology based on a set of internationally recognized criteria. Professionals with years of training and experience have created the syllabus.</p>
                            <p><b>Reading Section : </b>This section considers the test-takers reading proficiency. The TOEFL curriculum provides a thorough overview of this subject, which requires test takers to read three to four paragraphs. There are around 10–12 questions for each reading chapter, and there are 54–72 minutes in total. A solid understanding of the paragraph’s substance is required for the replies, and getting excellent marks in this area needs practice.</p>
                            <h6 className="subhead">Exam Format</h6>
                            <ol className="subhead-ul">
                                <li>54-72 min of the allotted time.</li>
                                <li>3-4 reading passages.</li>
                                <li>Approximately 40 questions.</li>
                            </ol>
                            <p className="loan-elegibility-des"><b>Writing section :</b> The section involves writing essays that must be logical, organized, and understandable. The writing portion of the TOEFL exam is given a lot of weight in the syllabus. It is required for exam takers to have a unique point of view and to manage the assigned topic effectively.</p>
                            <h6 className="subhead">Structure of the exam</h6>
                            <ol className="subhead-ul">
                                <li>A combination of writing, listening, and reading. You have two minutes to listen, three minutes to read, and fifteen minutes to write.</li>
                                <li>Two questions from a distinct assignment.</li>
                                <li>Total time allocated is 50 minutes.</li>
                            </ol>
                            <p><b>Listening section :</b> There are a variety of questions from both long and short conversations in this area. The main focus of the TOEFL course is the ability to converse. As a result, one must listen carefully to what is mentioned in the audio. The short conversation will have one multiple-choice question, while the extended talk part will include additional questions.</p>
                            <h6 className="subhead">Exam Format</h6>
                            <ol className="subhead-ul">
                                <li>30-question, three-to-four-minute talks lasting between 500 and 800 words each. Six questions from every section.</li>
                                <li>Each segment consists of three minutes, two to four discussions with around five questions. Twelve questions in all.</li>
                                <li>The total amount of questions is 40.</li>
                                <li>There is a 40–60 minute time limit overall.</li>
                            </ol>
                            <p className="loan-elegibility-des"><b>Speaking Section :</b> This portion mostly assesses a student’s fluency in speaking English. Examiners can assess a student’s skill in this area without making significant errors. For this portion, students should always practice a lot. It is the section of the TOEFL Exam syllabus with the highest rating, therefore students who can speak the language well always have an advantage over others.</p>
                            <h6 className="subhead">Exam Structure –</h6>

                            <ol className="subhead-ul">
                                <li>One independent job with a 15-second preparation period and a 45-second response time.</li>
                                <li>Three integrated tasks: a combination of reading, writing, and listening with a 30-second preparation period and a 60-second reaction time.</li>
                                <li>Total number of questions: 4</li>
                                <li>There are exactly 17 minutes available.</li>
                            </ol>
                            <h5 className="about-head">TOEFL Test Format</h5>
                            <p className="loan-elegibility-des">One should study the syllabus in its entirety and use the recommended resources to get ready if one wants to do well. Six days after the exam is over, the results are announced on the official website.<br /><br />
                                Students may choose to provide up to four selections when it comes to their preferred university. The scorecard will be delivered directly to those universities.<br /><br />
                                The TOEFL Exam curriculum expands on the three exam patterns available: online (test from home), iBT (internet-based test), and PBT (paper-based exam). The PBT is only accessible in areas with inadequate internet connectivity, meaning that students have no other option. It is not available in every country.</p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Toefl;